import types from './types';

const INITIAL_STATE = {
  isFetchingReport: false,
  isFetchingExcel: false,

  result: [],
};

const appMemberReportsReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_MEMBER_REPORT_PRINT_FILE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingReport: true,
      };

    case types.GET_MEMBER_REPORT_PRINT_FILE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingReport: false,
      };

    case types.GET_MEMBER_REPORT_PRINT_FILE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingReport: false,
      };

    case types.GET_MEMBER_REPORT_EXCEL_FILE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingExcel: true,
      };

    case types.GET_MEMBER_REPORT_EXCEL_FILE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingExcel: false,
      };

    case types.GET_MEMBER_REPORT_EXCEL_FILE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingExcel: false,
      };

    

    default:
      return state;
  }
};

export default appMemberReportsReducer;
